import { updateConnectorConfigDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const updateConnectorConfigCallable = getCallable(
  updateConnectorConfigDefinition,
);
